module.exports = __webpack_public_path__ + "img/generate.c2db2705.jpg";